import { defineRouteMiddleware, navigateTo } from '@/shared/utils/router.js';
import { useTeamStore } from '#modules/team/stores/team.store.js';
import { useAuthStore } from '#modules/auth/stores/auth.store.js';

export default defineRouteMiddleware(function enforceTwoFactor(to) {
    const authStore = useAuthStore();
    const teamStore = useTeamStore();

    if (to.name !== 'tfa setup' && teamStore.enforces2FA && !authStore.has2FA) {
        return navigateTo({ name: 'tfa setup' });
    }
});
